import useApiPrivateClient from '../../../hooks/useApiPrivateClient';
import { PaymentsOverview } from './overview.responses';

const usePaymentsOverviewService = () => {
  const api = useApiPrivateClient();

  const getOverview = () => api.get<PaymentsOverview>('/payments/overview');

  return { getOverview };
};

export default usePaymentsOverviewService;
